export const AppSelect = {
  STATUS: [
    { value: 0, label: 'Chờ duyệt', color: '#FF9500' },
    { value: 1, label: 'Đã duyệt', color: '#5CB85C' },
  ],
  PARTNER_STATUS: [
    { value: 0, label: 'Chờ duyệt', color: '#FF9500' },
    { value: 1, label: 'Đã duyệt', color: '#5CB85C' },
    { value: 2, label: 'Ngừng hợp tác', color: '#EB3D4D' },
  ],
  TAG_STATUS: [
    { value: 0, label: 'Ẩn', color: '#FF9500' },
    { value: 1, label: 'Hiện', color: '#5CB85C' },
  ],
  UI_TYPE: [
    { value: 1, label: 'Khối Trầm Tuệ ở màn trang chính mua sắm' },
    { value: 2, label: 'Không gian thờ ở màn trang chính mua sắm' },
    { value: 3, label: 'Hương sạch ở màn trang chính mua sắm' },
    { value: 4, label: 'Du lịch - Đi lại ở màn trang chính mua sắm' },
    { value: 5, label: 'Trầm Tuệ ở màn chi tiết theo tag' },
    { value: 6, label: 'Không gian thờ ở màn chi tiết theo tag' },
    { value: 7, label: 'Hương sạch ở màn chi tiết theo tag' },
  ],
  ORDER_STATUS: [
    { value: 'Đã thanh toán', label: 'Đã thanh toán', color: '#5CB85C' },
    { value: 'Đã xác nhận', label: 'Đã xác nhận', color: '#5CB85C' },
    { value: 'Đang giao hàng', label: 'Đang giao hàng', color: '#FF9500' },
    { value: 'Giao thành công', label: 'Giao thành công', color: '#5CB85C' },
    { value: 'Hoàn thành', label: 'Hoàn thành', color: '#5CB85C' },
    { value: 'Đã hủy', label: 'Đã hủy', color: '#FF9500' },
  ],
  MINI_APP_INFO_SHARE: [
    { value: 'customer_id', label: 'customer_id' },
    { value: 'platform', label: 'platform' },
    { value: 'referral_id', label: 'referral_id' },
    { value: 'miniapp_id', label: 'miniapp_id' },
    { value: 'user_id', label: 'user_id' },
    { value: 'full_name', label: 'full_name' },
    { value: 'phone', label: 'phone' },
    { value: 'dob', label: 'dob(ngày sinh)' },
  ],
  DISPLAY_PLACE: [
    { value: 'Gian_Hang_Mua_Sam', label: 'Tab [Mua sắm]' },
    { value: 'App_XemNgayTot', label: 'Tính năng Xem ngày tốt' },
    { value: 'App_ChaoXuan', label: 'Chào xuân' },
  ],
};
